import React from 'react';
import { SearchCard } from '../types';
import { BaseFeaturedSearchCard } from '../Base';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import {
  Price,
  GrayUIText,
  Title,
  BottomContent,
  BlackUIText,
  UnitPriceText,
  FeaturedReserveBarTimerWrapper,
} from '../Base/styles';
import { ReserveBar } from '../../../reserveBar';
import { BoxConditionIcon, TruckIcon, MapMarkerIcon } from '../../../../assets';
import { Timer } from '../../../timer';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[1].rem};
  margin: ${theme.spacings[2].rem};
  width: 149px;
  justify-content: space-between;
`;

const StyledTimer = styled(Timer)`
  margin-left: 2px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  grid-template-rows: minmax(136px, 1fr) repeat(auto-fill, 169px);
`;

const StyledPrice = styled(Price)`
  ${theme.typography.headings[6]['sm-lg']};
`;

export const WineAuctionFeaturedSearchCard: React.FC<
  SearchCard<'WineAuction'>
> = ({
  title,
  reserveStatus,
  reserveStatusMapping,
  enforceReserve,
  condition,
  location,
  isDelivery,
  data,
  type,
  timeLeft,
  ...props
}) => {
  return (
    <BaseFeaturedSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <Container>
          <FeaturedReserveBarTimerWrapper>
            {reserveStatus && (
              <ReserveBar
                reserveStatus={reserveStatus}
                reserveStatusMapping={reserveStatusMapping}
              />
            )}
          </FeaturedReserveBarTimerWrapper>
          <StyledTimer format="short" closingTime={timeLeft} />
          <div>
            <StyledPrice>{data.secondaryPrice.price}</StyledPrice>
            <BlackUIText>
              <UnitPriceText>
                {data.perBottlePrice} Per {data.unitPricing.unitName}
              </UnitPriceText>
            </BlackUIText>
          </div>
          <BottomContent>
            <GrayUIText>
              <BoxConditionIcon
                width={16}
                fill={theme.colors.neutrals.solidGrays[3]}
              />
              {condition}
            </GrayUIText>
            {(condition as string).length < 13 && (
              <GrayUIText>
                {isDelivery ? (
                  <>
                    <TruckIcon
                      width={16}
                      fill={theme.colors.neutrals.solidGrays[3]}
                    />
                    Delivery
                  </>
                ) : (
                  <>
                    <MapMarkerIcon
                      width={16}
                      fill={theme.colors.neutrals.solidGrays[3]}
                    />
                    {location}
                  </>
                )}
              </GrayUIText>
            )}
          </BottomContent>
        </Container>
      </Content>
    </BaseFeaturedSearchCard>
  );
};
